export const timeAgo = (dateString: string) => {
  const now = new Date();
  const pastDate = new Date(dateString);
  const diffInSeconds = Math.floor((now.getTime() - pastDate.getTime()) / 1000);

  if (isNaN(pastDate.getTime())) {
    return 'Invalid date';
  }

  if (diffInSeconds < 60) {
    return `${diffInSeconds} second${diffInSeconds !== 1 ? 's' : ''} ago`;
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return `${diffInMinutes} minute${diffInMinutes !== 1 ? 's' : ''} ago`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  return `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`;
};

export const sortByDate = (a?: string, b?: string) => {
  const timeA = a ? Date.parse(a) : NaN;
  const timeB = b ? Date.parse(b) : NaN;

  const validA = !isNaN(timeA);
  const validB = !isNaN(timeB);

  if (!validA && !validB) {
    return 0;
  }
  if (!validA) {
    return 1;
  }
  if (!validB) {
    return -1;
  }
  return timeB - timeA;
};
